


































































































































































































import _ from 'lodash'
import confirmMixin from '@/modules/common/mixins/confirmMixin'
import Component, { mixins } from 'vue-class-component'
import { contactTypes } from '@/modules/pass/types/contactType'
import move from 'lodash-move'
import notificationService from '@/modules/common/services/notificationService'
import page from '@/modules/common/components/page.vue'
import { Prop } from 'vue-property-decorator'
import Pass, { Contact } from '@/modules/pass/domain/pass'
import passService from '@/modules/pass/domain/passService'
import selectField from '@/modules/common/components/form/selectField.vue'
import textAreaField from '@/modules/common/components/form/textAreaField.vue'
import textField from '@/modules/common/components/form/textField.vue'
import validationMixin from '@/modules/common/components/form/validationMixin'
import vForm from '@/modules/common/components/form/vForm.vue'

@Component({
  components: { page, selectField, textAreaField, textField, vForm }
})
export default class PassForm extends mixins(validationMixin, confirmMixin) {
  contactTypes = contactTypes

  @Prop({ type: Pass, required: true }) model!: Pass

  onSubmit () {
    passService.save(this.model).then(() => {
      notificationService.success('pass.edit.success')
      this.$router.push('/detail')
    }).finally(this.unprotect)
  }

  addContact () {
    this.model.draftProps.contacts.push(new Contact())
  }

  deleteContact (contact: Contact) {
    this.model.draftProps.contacts = _.without(this.model.draftProps.contacts, contact)
  }

  positionDown (contact: Contact) {
    // because of filters we need to set position of next item in order
    const contactIndex = this.model.draftProps.contacts.indexOf(contact)
    const indexOfNextItem = contactIndex + 1
    // last index check
    if (this.model.draftProps.contacts.length <= indexOfNextItem) {
      return
    }

    this.model.draftProps.contacts = move(this.model.draftProps.contacts, contactIndex, indexOfNextItem)
  }

  positionUp (contact: Contact) {
    // because of filters we need to set position of next item in order
    const contactIndex = this.model.draftProps.contacts.indexOf(contact)
    const indexOfPrevItem = contactIndex - 1
    // first index check
    if (indexOfPrevItem < 0) {
      return
    }
    this.model.draftProps.contacts = move(this.model.draftProps.contacts, contactIndex, indexOfPrevItem)
  }
}
